export enum ERecipeUploadFormItem {
    RECIPE_UPLOAD = "recipe-upload",
}
